import AppoinmentHistory from "../components/InterBranchAppointmentHistory/InterBranchAppointmentHistory";
import BookConsultNow from "../components/BookConsultNow/BookConsultNow";
import ChooseDoctor from "../components/BookConsultNow/Components/ChooseDoctor/ChooseDoctor";
import ConsultationHistory from "../components/BookConsultNow/Components/ConsultationHistory/ConsultationHistory";
import PatientDetail from "../components/BookConsultNow/Components/PatientDetails/PatientDetail";
import AllergiesandMedication from "../components/BookConsultNow/Components/PatientMedicalComponent/Components/AllergiesandMedication/AllergiesandMedication";
import LifestyleAndPreExistingCondition from "../components/BookConsultNow/Components/PatientMedicalComponent/Components/LifestyleAndPreExistingCondition/LifestyleAndPreExistingCondition";
import PatientVitals from "../components/BookConsultNow/Components/PatientMedicalComponent/Components/Patient Vitals/PatientVitals";
import PatientMedicalComponent from "../components/BookConsultNow/Components/PatientMedicalComponent/PatientMedicalComponent";
import ConsultationDetails from "../components/PatientDetails/Components/ConsultationDetails/ConsultationDetails";
import PatientDetails from "../components/PatientDetails/PatientDetails";
import Assets from "../components/Layout/Assets";
import { AppointmentHistoryIcon, BookConsultNowIcon, FaqIcon, HelpIcon, PatientdetailsIcon, ScheduleAppointmentIcon, TestSystemIcon } from "../assets/Logos/Icons";


export const interbranchHomeSideMenu = [
    {
        tittle: "APPOINTMENT",
        options: [
            {
                name: "Book & Consult Now",
                ico: <BookConsultNowIcon />,
                component: <BookConsultNow key="bookconsultnow" />,
                date: "",
                target: "bookandconsult"
            },
            {
                name: "Schedule Appointment",
                ico: <ScheduleAppointmentIcon />,
                component: <BookConsultNow key="scheduleappointment" isSchedule />,
                target: "scheduleappointment"

            },
            {
                name: "Appointment History",
                ico: <AppointmentHistoryIcon />,
                component: <AppoinmentHistory />,
                target: "appointmenthistory"
            },
        ]
    },
    {
        tittle: "PATIENTS",
        options: [
            {
                name: "Patient Details",
                ico: <PatientdetailsIcon />,
                // component:<PatientDetails/>,
                target:"patientDetails"
            },
        ]
    },
    // {
    //     tittle: "SETTINGS",
    //     options: [
    //         {
    //             name: "FAQ",
    //             ico: <FaqIcon />,
    //             target:"faq"
    //         },
    //         {
    //             name: "Test My System",
    //             ico: <TestSystemIcon/>,
    //             target:"testmysystem"
    //         },
    //         {
    //             name: "I Need Help",
    //             ico: <HelpIcon/>,
    //             target:"help"
    //         },
    //     ]
    // },

]


export const bookConsultNowTopNavMenus = [
    {
        name: "Patient Details",
        component: <PatientDetail />,
        target: "patientdetails"
    },
    {
        name: "Choose Doctor",
        component: <ChooseDoctor />,
        target: "choosedoctor"
    },
    {
        name: "Patient Medical History",
        component: <PatientMedicalComponent />,
        target: "patientmedical"
    },
    {
        name: "Patient Consultation History",
        component: <ConsultationHistory />,
        target: "consultationhistory"
    }
]

export const l2navoptions = [
    {
        name: "Patient Vitals",
        component: <PatientVitals />,
        target: "patientvitals"

    },
    {
        name: " Lifestyle & Pre Existing Conditions",
        component: <LifestyleAndPreExistingCondition />,
        target: "lifestyle"
    },
    {
        name: "Allergies & Medications",
        component: <AllergiesandMedication />,
        target: "allergies"
    },

]

export const l2navoptionsPatientDetails = [
    {
        name: "Patient Vitals",
        component: <PatientVitals />
    },
    {
        name: " Lifestyle & Pre Existing Conditions",
        component: <LifestyleAndPreExistingCondition />
    },
    {
        name: "Allergies and Medication",
        component: <AllergiesandMedication />
    },
    {
        name: "Consultation Details",
        component: <ConsultationDetails />
    },

]

export const emergencyrelationship = [
    { option: "Father", value: "Father" },
    { option: "Mother", value: "Mother" },
    { option: "Brother", value: "Brother" },
    { option: "Sister", value: "Sister" },
    { option: "Son", value: "Son" },
    { option: "Daughter", value: "Daughter" },
    { option: "Grandfather", value: "Grandfather" },
    { option: "Grandmother", value: "Grandmother" },
    { option: "Friend", value: "Friend" },
    { option: "Wife", value: "Wife" },
    { option: "Husband", value: "Husband" },
    { option: "Cousin", value: "Cousin" },
    { option: "Aunt", value: "Aunt" },
    { option: "Uncle", value: "Uncle" },
    { option: "Other", value: "Other" },
  ];

export const yesNoOptions = [{ option: "Yes", value: "Yes" }, { option: "No", value: "No" }]

export const relationOption = [{ option: "Both", value: "Both" }, { option: "Mother", value: "Mother" }, { option: "Father", value: "Father" }, { option: "None", value: "None" }]

export const allergentOptions = [{ option: "Milk", value: "Milk" }, { option: "Dust", value: "Dust" }, { option: "Fire", value: "Fire" }]

export const sinceOptions = [{ option: "30 Minutes Before Breakfast", value: "30 Minutes Before Breakfast" },
{ option: "30 Minutes Before Dinner", value: "30 Minutes Before Dinner" },
{ option: "30 Minutes Before Food", value: "30 Minutes Before Food" },
{ option: "30 Minutes Before Lunch", value: "30 Minutes Before Lunch" },
{ option: "6 Hrs for Fever > 100 F", value: "6 Hrs for Fever > 100 F" },
{ option: "After Dinner", value: "After Dinner" },
{ option: "After Food", value: "After Food" },
{ option: "After Lunch", value: "After Lunch" },
{ option: "As Directed", value: "As Directed" },
{ option: "Before Food", value: "Before Food" },
{ option: "Every Fourth Hourly", value: "Every Fourth Hourly" },
{ option: "For Immediate Use", value: "For Immediate Use" },
{ option: "Four Times Daily", value: "Four Times Daily" },
{ option: "Half a Day-Evening", value: "Half a Day-Evening" },
{ option: "Half a Day-Evening and Noon", value: "Half a Day-Evening and Noon" },
{ option: "Half a Day-Morning", value: "Half a Day-Morning" },
{ option: "Half a Day-Morning and Evening", value: "Half a Day-Morning and Evening" },
{ option: "Half a Day-Morning and Noon", value: "Half a Day-Morning and Noon" },
{ option: "Half a Day-Noon", value: "Half a Day-Noon" },
{ option: "Half Tablet", value: "Half Tablet" },
{ option: "Hourly", value: "Hourly" },
{ option: "Thrice Daily", value: "Thrice Daily" },
{ option: "On Alternate Days", value: "On Alternate Days" },
{ option: "On Empty Stomach", value: "On Empty Stomach" },
{ option: "Once Daily - Evening", value: "Once Daily - Evening" },
{ option: "Once Daily - Morning", value: "Once Daily - Morning" },
{ option: "Once Daily - Morning and Evening", value: "Once Daily - Morning and Evening" },
{ option: "Once Daily - Night", value: "HoOnce Daily - Nighturly" },
{ option: "Once Daily - Noon", value: "Once Daily - Noon" },
{ option: "Once a Month", value: "Once a Month" },
{ option: "Once a Week", value: "Once a Week" },
{ option: "SOS", value: "SOS" },
{ option: "Thrice a Day", value: "Thrice a Day" },
{ option: "Thrice Daily", value: "Thrice Daily" },
{ option: "Thrice Weekly", value: "Thrice Weekly" },
{ option: "Twice a Day - Noon and Night", value: "Twice a Day - Noon and Night" },
{ option: "Twice Daily", value: "Twice Daily" },
{ option: "Twice Daily - Morning and Evening", value: "Twice Daily - Morning and Evening" },
{ option: "Twice Daily - Morning and Night", value: "Twice Daily - Morning and Night" },
{ option: "Twice Daily - Morning and Noon", value: "Twice Daily - Morning and Noon" },
{ option: "Twice Daily - Noon and Evening", value: "Twice Daily - Noon and Evening" },
{ option: "Twice Weekly", value: "Twice Weekly" },
{ option: "Use when required", value: "Use when required" },
{ option: "With First Bite of Food", value: "With First Bite of Food" }
]

export const medicinesOptions = [{ option: "Dolo", value: "Dolo" }, { option: "Medicine 1", value: "Medicine 1" }, { option: "Medicine2", value: "Medicine2" }]

export const heightUnits = [{ option: "cm", value: "cm" }, { option: "ft", value: "ft" }, { option: "in", value: "in" }]

export const weightUnits = [{ option: "kg", value: "kg" }, { option: "lbs", value: "lbs" }]

export const statusOptions = [{ option: "Taking this", value: "Taking this" }, { option: "No longer taking this", value: "No longer taking this" }]

export const allergyStatusOptions = [{ option: "Having this", value: "Having this" }, { option: "No longer have this", value: "No longer have this" }]

export const bloodGroups = [{ option: "A+", value: "A%2B" },
{ option: "A-", value: "A%2D" },
{ option: "B+", value: "B%2B" },
{ option: "B-", value: "B%2D" },
{ option: "O+", value: "O%2B" },
{ option: "O-", value: "O%2D" },
{ option: "AB+", value: "AB%2B" },
{ option: "AB-", value: "AB%2D" }]

export const tempratureUnit = [{ option: "Celsius", value: "Celsius" }, { option: "Fahrenheit", value: "Fahrenheit" }]

export const pulseRateUnit = [{ option: "Beats/Min", value: "Beats/Min" }]

export const bloodPressureUnit = [{ option: "mmHG", value: "mmHG" }]

export const bodyTemperatureposition = [{ option: "Armpit", value: "Armpit" },
{ option: "Ear", value: "Ear" },
{ option: "Forehead", value: "Forehead" },
{ option: "Mouth", value: "Mouth" },
{ option: "Rectum", value: "Rectum" },
]

export const pulseRatePosition = [{ option: "Carotid Pulse(neck)", value: "Carotid Pulse(neck)" }, { option: "Radial Pulse(wrist)", value: "Radial Pulse(wrist)" }]

export const ALLERGY_REDUX_STATE = "allergiesRedux"
export const MEDICINE_REDUX_STATE = "medicinesRedux"

export const ADD_DATA_TO_ALLERGY_MEDICATION_REDUX = "ADD_DATA_TO_ALLERGY_MEDICATION_REDUX"
export const EDIT_DATA_TO_ALLERGY_MEDICATION_REDUX = "EDIT_DATA_TO_ALLERGY_MEDICATION_REDUX"
export const REMOVE_DATA_FROM_ALLERGY_MEDICATION_REDUX = "REMOVE_DATA_FROM_ALLERGY_MEDICATION_REDUX"


export const COMMON_DELETE_MODAL_NAME = "commonDeleteModal"
export const PATIENT_DETAILS_MODAL_NAME = "PatientDetailsModal"


export const CLEAR_INTERBRANCH_APPOINTMENT_FORM = "CLEAR_INTERBRANCH_APPOINTMENT_FORM"
export const SAVE_INTERBRANCH_APPOINTMENT_FORM_BOOK = "SAVE_INTERBRANCH_APPOINTMENT_FORM_BOOK"
export const SAVE_INTERBRANCH_APPOINTMENT_FORM_SCHEDULE = "SAVE_INTERBRANCH_APPOINTMENT_FORM_SCHEDULE"

export const CLEAR_INTERBRANCH_DATA = "CLEAR_INTERBRANCH_DATA"